import { createToken } from '@react-apps/core';
import type { UsersRepositoryImpl } from '../data/repositories/users.repository.impl';

export const UsersRepositoryToken =
  createToken<UsersRepositoryImpl>('UsersRepository');
